import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

const question_audio_request = () => {
  return {
    type: questionsTypes.audio.request
  }
}

const question_audio_success = (response) => {
  return {
    type: questionsTypes.audio.success,
    payload: response.data
  }
}

const question_audio_failure = (messages) => {
  return {
    type: questionsTypes.audio.failure,
    payload: messages
  }
}

const question_audio = (question_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(question_audio_request())
    // Request
    axios({
      method: 'get',
      url: formatRoute(QUESTIONS_ROUTES.audio, {id: question_id}),
      responseType: 'blob'
    }).then( response => {
      // success
      dispatch( question_audio_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error downloading audio."]
      }
      // dispatch( try_force_logoff(error.response) )
      // window.showSnackbar('error', errors)
      dispatch( question_audio_failure(errors))
    })
  }

}

export {
  question_audio,
  question_audio_request
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/get_audio.js